import { createFileRoute } from '@tanstack/react-router'
import { DesaOverview } from '../../../pages/DesaOverview'

// /desa/:slug → landing publik desa
export const Route = createFileRoute('/desa/$slug/')({
  component: () => {
    const { slug } = Route.useParams()
    return <DesaOverview slug={slug} />
  },
})
